import { CardRefundStatus } from "@/components/CardRefundStatus";
import { Money, LocalMoney } from "@/components/Money";
import { Mono } from "@/components/Mono";
import { RelatedLink } from "@/components/RelatedLink";
import { COLLECTIONS } from "@/firestore/collections";
import type { CardRefundDoc } from "@/firestore/cardRefunds";
import type { WithDocId } from "@/firestore/types";
import { refundMerchant, REFUND_STATE_LABELS } from "@/pages/card-refunds/presentation";
import type { EntityConfig } from "../types";
import { monoCol, moneyCol, relatedCol, textCol, timeCol } from "../shared";

type R = WithDocId<CardRefundDoc>;

export const cardRefundConfig: EntityConfig<CardRefundDoc> = {
  key: "cardRefund",
  collection: COLLECTIONS.cardRefunds,
  title: "Card refund",
  pluralTitle: "Card refunds",
  ownerField: "owner",
  defaultOrder: [["createdAt", "asc"]],
  columns: [
    {
      id: "status",
      header: "Status",
      accessorFn: (r) => REFUND_STATE_LABELS[r.queueState],
      cell: ({ row }) => <CardRefundStatus state={row.original.queueState} />,
    },
    textCol<R>("merchant", "Merchant", refundMerchant),
    moneyCol<R>("amount", "Refund (USDC)", (r) => r.amountMicroUsdc),
    relatedCol<R>("owner", "User", "user", (r) => r.owner),
    relatedCol<R>("claimedBy", "Assigned to", "user", (r) => r.claimedBy),
    timeCol<R>("providerCompletedAt", "Provider settled", (r) => r.providerCompletedAt),
    timeCol<R>("createdAt", "Received", (r) => r.createdAt),
    monoCol<R>("id", "Refund ID", (r) => r.id),
  ],
  subtitle: (d) => <Mono value={d.id} />,
  detailFields: (d) => [
    { label: "Amount", value: <Money micro={d.amountMicroUsdc} /> },
    {
      label: "Merchant amount",
      value: <LocalMoney minor={d.localAmountMinor} currency={d.localCurrency} />,
    },
    { label: "Merchant", value: refundMerchant(d) },
    { label: "User", value: <RelatedLink entity="user" id={d.owner} /> },
    { label: "Card", value: <RelatedLink entity="card" id={d.card} /> },
  ],
};
